import { render } from "./ResumoHP.vue?vue&type=template&id=c823416e"
import script from "./ResumoHP.vue?vue&type=script&lang=js"
export * from "./ResumoHP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__